import { StarRating } from "@/components/StarRating";

export const TestimonialCard = ({ t }) => (
  <figure className="bg-white border border-[#ECEAE4] p-8 sm:p-10 h-full flex flex-col" data-testid={`testimonial-${t.id}`}>
    <StarRating rating={t.rating} />
    <blockquote className="font-display text-xl sm:text-2xl leading-snug text-[#2C2A29] mt-6 flex-1">
      “{t.quote}”
    </blockquote>
    <figcaption className="mt-8 pt-6 border-t border-[#ECEAE4]">
      <p className="font-medium text-[#2C2A29]">{t.author_name}</p>
      <p className="text-sm text-[#5E5A54] font-light">{t.author_title}{t.location ? ` · ${t.location}` : ""}</p>
    </figcaption>
  </figure>
);
